import { render, staticRenderFns } from "./ChangeRateWidget.vue?vue&type=template&id=907fa92e&scoped=true"
import script from "./ChangeRateWidget.vue?vue&type=script&lang=ts"
export * from "./ChangeRateWidget.vue?vue&type=script&lang=ts"
import style0 from "./ChangeRateWidget.vue?vue&type=style&index=0&id=907fa92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907fa92e",
  null
  
)

export default component.exports